import React, { useEffect, useContext } from 'react';
import Flow from 'components/common/flow/flow';
import Heading from 'components/common/heading/heading';
import AppContext from 'contexts/appContext';
import SiteContext from 'components/shared/siteContext/siteContext';
import './employeesPage.css';

import image_headshot from 'assets/images/employee-headshot.jpg';

export default function EmployeesPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  useEffect(() => {
    setAppArea(AppContext.Areas.Employees, 'Manage Employees');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Employees', selected: true }]);
  }, []);

  const employees = [
    {
      id: 1,
      color: '#9b2caf',
      name: 'John Smith',
      initials: 'JS',
      employeeNumber: 4,
      altEmployeeNumber: 12,
      dailyHoursWorked: 4,
      weeklyHoursWorked: 21,
      isClockedIn: true,
      imageURL: image_headshot,
      jobs: [
        {
          name: 'Server',
          departmentName: 'Server',
        },
        {
          name: 'Training',
          departmentName: 'Server',
        },
      ],
    },
    {
      id: 2,
      color: '#dc3d3d',
      name: 'Patrick Reed',
      initials: 'PR',
      employeeNumber: 7,
      altEmployeeNumber: 102,
      dailyHoursWorked: 0,
      weeklyHoursWorked: 30,
      isClockedIn: false,
      jobs: [
        {
          name: 'Manager',
          departmentName: '',
        },
      ],
    },
    {
      id: 3,
      color: '#0095ff',
      name: 'Derek Schissler',
      initials: 'DS',
      employeeNumber: 1,
      altEmployeeNumber: 400,
      dailyHoursWorked: 8,
      weeklyHoursWorked: 16,
      isClockedIn: false,
      jobs: [
        {
          name: 'Busser',
          departmentName: '',
        },
        {
          name: 'Worker',
          departmentName: '',
        },
        {
          name: 'Training',
          departmentName: '',
        },
      ],
    },
    {
      id: 4,
      color: '#2a8214',
      name: 'Anna Reed',
      initials: 'AR',
      employeeNumber: 8,
      altEmployeeNumber: 103,
      dailyHoursWorked: 7,
      weeklyHoursWorked: 7,
      isClockedIn: true,
      jobs: [
        {
          name: 'Manager',
          departmentName: '',
        },
        {
          name: 'Worker',
          departmentName: '',
        },
      ],
    },
  ];

  return (
    <Flow>
      <Flow.Header>
        <Heading>
          <SiteContext.Button loaded={true} hierarchyId={141} onSelectSite={() => null} />
        </Heading>
      </Flow.Header>

      <Flow.Body>
        <div className='row justify-content-md-center mx-0 mt-4'>
          <div className='row col-12 col-xl-10'>
            {employees.map((employee, index) => <ContactBox employee={employee} key={index} />)}
          </div>
        </div>
      </Flow.Body>
    </Flow>
  );
}

function ContactBox(props) {
  const employee = props.employee;

  const renderOtherJobs = () => {
    if (employee.jobs.length <= 1) {
      return <div>&nbsp;</div>;
    }
    else if (employee.jobs.length === 2) {
      return <div className='text-thick'>+ 1 other job</div>;
    }
    else {
      return <div className='text-thick'>+ {employee.jobs.length - 1} other jobs</div>;
    }
  };

  const renderClockedIn = () => {
    if (!employee.isClockedIn) {
      return <div className='mt-1'>&nbsp;</div>;
    }
    else {
      return (
        <div className='mt-1'>
          <span className='contact-on-the-clock'>ON THE CLOCK</span>
        </div>
      );
    }
  };

  return (
    <div className='col-12 col-md-6 col-lg-4'>
      <div className='employees-contact-box'>
        <a className='row' href={`/Employees/${employee.id}`}>
          <div className='col-4 contact-left-side'>
            {
              employee.imageURL ?
                <img className='contact-image' src={employee.imageURL} alt={employee.initials} />
                :
                <div className='contact-image-placeholder' style={{ backgroundColor: employee.color }}><div>{employee.initials}</div></div>
            }
            <div className='mt-2 text-thick'>{employee.jobs[0].name}</div>
            {renderOtherJobs()}
          </div>
          <div className='col-8 contact-right-side'>
            <h4 className='text-thicker mb-3'>{employee.name}</h4>
            <div className='mt-3'>
              <div><span className='text-thick mr-1'>Employee #</span> {employee.employeeNumber}</div>
              <div><span className='text-thick mr-1'>Alt Employee #</span> {employee.altEmployeeNumber}</div>
            </div>
            <div className='mt-3'>
              <div><span className='text-thick mr-1'>Hours worked today</span> {employee.dailyHoursWorked}</div>
              <div><span className='text-thick mr-1'>Hours worked this week</span> {employee.weeklyHoursWorked}</div>
              {renderClockedIn()}
            </div>
          </div>
        </a>
      </div>
    </div>
  );
}